import { FormInitializerReturnType } from 'src/Configuration/validation'
import { WallboxConfigurationModel } from '../..'
import { BidiConnectModel } from '../../models/wallbox-configuration/wallbox-configuration-settings-form.model'
import { useWallboxSettingsFormValidationFields } from '..'
import { object } from 'yup'

/**
 * Initializes the form for editing wallbox bidi settings
 * @param model WallboxConfigurationModel
 * @returns initialValues and validationSchema for wallbox bidi settings form
 */
export const useWallboxBidiFormInitializer = (model?: WallboxConfigurationModel): FormInitializerReturnType<BidiConnectModel, BidiConnectModel> => {
  const validationFields = useWallboxSettingsFormValidationFields()
  const initialValues = {
    diagBatCapacity: model?.diagBatCapacity ?? 0,
    bidiModeActive: Boolean(model?.bidiModeActive),
    rfidReaderEnabled: model?.rfidReaderEnabled,
    authRequired: Boolean(model?.authRequired),
  }
  const validationSchema = object().shape({
    diagBatCapacity: validationFields.diagBatCapacityField(),
    bidiModeActive: validationFields.bidiModeActiveField(),
    rfidReaderEnabled: validationFields.rfidReaderEnabledField(),
    authRequired: validationFields.authRequiredField(),
  })
  return { initialValues, validationSchema }
}
